/**
 * Board Media Placeholder Render
 *
 * Renders loading and empty placeholder blocks for board media areas.
 */

import { Roles } from "../../constants/roles";

interface BoardMediaPlaceholderParams {
    postId?: number | null;
    loadingText: string;
}

export class BoardMediaPlaceholderRender {
    public static createLoadingPlaceholder(params: BoardMediaPlaceholderParams): HTMLDivElement {
        const { postId, loadingText } = params || { loadingText: "" };

        const root = document.createElement("div");
        root.className = "board-placeholder";
        root.setAttribute("data-role", Roles.BOARD_MEDIA_PLACEHOLDER);
        root.setAttribute("data-placeholder-variant", "loading");
        if (typeof postId === "number" && Number.isFinite(postId) && postId > 0) {
            root.setAttribute("data-post-id", String(postId));
        }

        const icon = document.createElement("div");
        icon.className = "placeholder-icon loading-animation";

        const dots = document.createElement("div");
        dots.className = "loading-dots";
        for (let index = 0; index < 3; index += 1) {
            const dot = document.createElement("div");
            dot.className = "dot";
            dots.appendChild(dot);
        }

        icon.appendChild(dots);

        const text = document.createElement("div");
        text.className = "placeholder-text loading-placeholder";
        text.textContent = String(loadingText ?? "");

        root.appendChild(icon);
        root.appendChild(text);

        return root;
    }
}
